import React from "react";
import { TableCell, TableRow } from "../../../shadcn/components/ui/table";
import { USER_ROLES } from "../../../utility/Enum";

const TeamsTableRow = ({ data = {} }) => {
  const isTeamAdmin = data?.teamAdminUsers.find(
    (admin) => admin === data.userId
  );

  return (
    <TableRow>
      <TableCell role="rowheader" className="px-4 font-medium">{data.name}</TableCell>
      <TableCell className="px-4">{data.club?.name}</TableCell>
      <TableCell className="px-4">{data.teamCode}</TableCell>
      <TableCell className="px-4">
        {isTeamAdmin ? USER_ROLES.TEAM_ADMIN : USER_ROLES.COACH}
      </TableCell>
    </TableRow>
  );
};

TeamsTableRow.propTypes = {};

export default TeamsTableRow;
